<div class="loading" *ngIf="!loaded">
    <mat-spinner [strokeWidth]="2" diameter="36"></mat-spinner>
</div>

<div class="loaded" *ngIf="loaded && post">
    <app-news-overlay [postObj]="post"></app-news-overlay>
</div>